import { ComponentWithChildrenType } from '@/types';
import * as Styles from './ChartCard.styles';

export default function ChartCard({ children, ...props }: ComponentWithChildrenType): JSX.Element {
  return <Styles.Card {...props}>{children}</Styles.Card>;
}
